<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="17.704" height="19.73" viewBox="0 0 17.704 19.73">
  <g id="_23430022_更新済み_" data-name="23430022 [更新済み]" transform="translate(0.487 8.229)">
    <path id="合体_32" data-name="合体 32" d="M.014,18.23C0,18.1,0,17.975,0,17.846V16.475A7.349,7.349,0,0,1,5.746,9.6a5.09,5.09,0,1,1,4.713,0A7.35,7.35,0,0,1,16.2,16.475v1.371c0,.129,0,.254-.01.385Z" transform="translate(0.264 -7.479)" fill="none" stroke-linejoin="round" stroke-width="1.5"/>
  </g>
</svg>

</template>
